// src/helpers/factories/menuTypeCardFactory.ts
var menuTypeCardFactory = (menuTypes) => {
  return Object.values(menuTypes).map((menuType) => {
    const isActive = menuType.active;
    return {
      id: menuType.menuTypeId,
      title: menuType.name,
      description: menuType.name,
      itemCount: menuType.itemIds.length,
      isActive,
      activeFilter: isActive ? 1 : 2
    };
  });
};
var dropdownMenuTypeOptionFactory = (menuTypes) => Object.values(menuTypes).map((menuType) => ({
  label: menuType.name,
  value: menuType.menuTypeId,
  inActive: !menuType.active
}));

export { dropdownMenuTypeOptionFactory, menuTypeCardFactory };
